const adminOrganization = {
  actions: {
    addMember: '新增成员',
    batchDisable: '批量停用',
    cancel: '取消',
    confirm: '确认',
    createMember: '新建',
    createDepartment: '新建部门',
    delete: '删除',
    deleteDepartment: '删除部门',
    deleteMember: '删除成员',
    disable: '停用',
    edit: '编辑',
    enable: '启用',
    manage: '管理',
    retry: '重试',
    resetPassword: '重置密码',
    save: '保存',
    settings: '设置',
    view: '查看',
    viewAttributes: '查看同步扩展信息',
  },
  common: {
    allDepartments: '全部部门',
    allStatuses: '全部状态',
    loading: '正在加载',
    noDepartment: '未分配',
    selectedCount: '已选择 {{count}} 项',
    selectCompany: '选择组织',
  },
  errors: {
    batchStatusPartial: '部分成员状态更新失败',
    deleteDefaultDepartment: '默认未分配部门不能删除。',
    deleteDepartmentWithChildren: '请先处理下级部门后再删除。',
    deleteDepartmentWithMembers: '请先移除或转移部门成员后再删除。',
    deleteRootDepartment: '根组织不能删除。',
    loadDescription: '组织和成员数据加载失败，请稍后重试。',
    loadTitle: '无法加载部门管理数据',
    noCompany: '暂无可用组织',
    removeMemberPartial: '部分成员移出失败，已刷新成功移出的成员。',
    submitFailed: '操作失败，请稍后重试。',
    syncReadOnly: '组织正在同步，部门和成员的手动修改已暂时停用；数据读取不受影响。',
  },
  memberAccounts: {
    attributesDrawer: {
      copied: '已复制',
      copy: '复制 JSON',
      description:
        '这些信息由企业目录、学校系统等身份来源同步，用于补充成员资料和排查同步结果。只有在 IdP Scope 中明确配置的字段才会共享给外部系统。',
      empty: '当前成员暂无同步扩展信息',
      errorDescription: '无法读取该成员的同步扩展信息，请稍后重试。',
      errorTitle: '同步扩展信息加载失败',
      fieldCount: '已同步 {{count}} 个字段',
      formattedJson: '格式化后的原始同步数据',
      loading: '正在加载同步扩展信息',
      rawJson: '原始同步数据',
      title: '同步扩展信息 / {{name}}',
    },
    columnSelector: {
      label: '选择成员账号列表列',
      trigger: '列',
    },
    description: '管理成员账号、部门归属和启停状态。',
    drawer: {
      department: '所属部门',
      email: '成员邮箱账号',
      lastActiveAt: '最近活跃时间',
      name: '成员名称',
      namePlaceholder: '请输入成员名称',
      role: '角色权限',
      status: '状态',
      title: '管理成员账号',
      titleWithMember: '管理成员账号 / {{name}}',
      userId: '用户 ID',
      validation: {
        nameRequired: '请输入成员名称',
      },
    },
    createModal: {
      close: '关闭',
      confirm: '创建成员',
      email: '邮箱地址',
      emailPlaceholder: 'name@company.com',
      mustChangePassword: '首次登录强制修改密码',
      name: '成员名称',
      namePlaceholder: '请输入成员名称',
      title: '新建成员账号',
      validation: {
        emailInvalid: '请输入有效邮箱',
        emailRequired: '请输入邮箱',
        nameRequired: '请输入成员名称',
      },
    },
    resetPasswordModal: {
      close: '关闭',
      confirm: '确认重置',
      description: '确认要重置 {{email}} 的密码吗？',
      impact: '确认后会生成临时密码；旧会话失效，下次登录需改密。',
      title: '确认重置密码',
    },
    empty: '暂无成员账号',
    searchLabel: '搜索成员名称',
    searchPlaceholder: '搜索成员名称',
    role: {
      admin: '管理员',
      unknown: '未设置',
      user: '普通成员',
    },
    status: {
      active: '活跃',
      banned: '停用',
    },
    sort: {
      createdAtAsc: '按创建时间升序排列',
      createdAtDesc: '按创建时间降序排列',
      lastActiveAtAsc: '按最近活跃时间升序排列',
      lastActiveAtDesc: '按最近活跃时间降序排列',
    },
    table: {
      actions: '操作',
      createdAt: '创建时间',
      department: '部门',
      email: '成员邮箱账号',
      lastActiveAt: '最近活跃时间',
      name: '成员名称',
      role: '角色权限',
      status: '状态',
    },
    title: '成员账号',
    workspaceLabel: '成员账号工作区',
  },
  organization: {
    addMemberDialog: {
      empty: '暂无可添加成员',
      searchLabel: '搜索成员',
      searchPlaceholder: '搜索成员名称或邮箱',
      subtitle: '把成员加入 {{name}}。',
      title: '新增成员',
    },
    createDepartmentDialog: {
      nameLabel: '部门名称',
      namePlaceholder: '请输入部门名称',
      subtitle: '新部门会创建在 {{name}} 下。',
      title: '新建部门',
    },
    deleteDepartmentDialog: {
      subtitle: '删除后无法恢复：{{name}}',
      title: '删除部门',
    },
    description: '管理部门层级和成员归属。',
    emptyMemberAddAction: '点击添加成员',
    emptyMemberSearchResults: '没有匹配的成员',
    emptyMembers: '当前组织范围内暂无成员',
    memberSearchLabel: '搜索成员名称或邮箱',
    memberSearchPlaceholder: '请输入成员名称或邮箱',
    orgSearchLabel: '搜索组织',
    orgSearchPlaceholder: '请输入组织',
    renameDepartmentDialog: {
      nameLabel: '部门名称',
      namePlaceholder: '请输入部门名称',
      title: '编辑部门',
    },
    settingsDrawer: {
      cronExpression: '同步 cron',
      lastRunCompletedAt: '最近完成时间',
      lastRunMessage: '最近运行消息',
      lastRunStatus: '最近运行状态',
      lockActive: '同步中',
      lockCompanyId: '锁定公司 ID',
      lockInactive: '未锁定',
      lockSource: '锁定来源',
      lockStartedAt: '锁定开始时间',
      lockStatus: '锁定状态',
      organizationName: '组织默认名称',
      organizationNameTooltip: '未开启组织同步时，顶层组织会显示这个名称。',
      runtimeStatus: '运行状态',
      runStatus: {
        abandoned: '已放弃',
        failed: '失败',
        running: '运行中',
        success: '成功',
      },
      syncInfo: '同步信息',
      syncCompanyId: '同步公司 ID',
      syncEnabled: '启用组织同步',
      syncSource: '同步来源',
      tabs: {
        basic: '基础信息',
        label: '组织设置分栏',
        sync: '组织同步',
      },
      title: '组织设置',
      validation: {
        organizationNameRequired: '请输入组织名称',
      },
    },
    table: {
      actions: '操作',
      email: '成员邮箱账号',
      name: '成员名称',
      role: '角色权限',
      source: '来源',
    },
    title: '部门管理',
    treeTitle: '部门',
    workspaceLabel: '部门管理工作区',
  },
  syncSettings: {
    actions: {
      pullExternalNow: '立即拉取外部数据',
      pullingExternal: '正在拉取外部数据',
      saveSettings: '保存设置',
      syncToHubNow: '立即同步到 Hub',
    },
    description: '分别管理外部数据拉取、Hub 组织数据同步与运行记录。',
    external: {
      cronError: '请输入六段式 Cron 表达式。',
      cronHint: '例如：0 0 18 * * *',
      cronTooltip: 'authz 使用包含秒的六段式 Cron，并按 UTC 时区执行。',
      loadErrorDescription: '无法读取 authz 同步配置，请检查服务地址和运行状态。',
      manualEyebrow: '外部数据源 → Authz 共享源表',
      manualTitle: '手动拉取',
      manualTooltip:
        '触发 authz 从外部组织数据源拉取最新数据，并写入 accounts、org_units 和 user_org_relations；不会自动刷新 Hub 组织视图。',
      pipeline: '外部数据源 → Authz 共享源表',
      settingsTitle: '外部数据同步设置',
      settingsTooltip:
        '定时同步由 authz 调度和执行，只负责刷新共享源表，不负责更新 Hub 内部组织数据。',
      uninitializedNotice: '当前 authz 未返回同步配置。请确认启停状态和 Cron 后保存，完成初始化。',
      uninitializedTitle: '同步设置尚未初始化',
    },
    feedback: {
      externalNotInitialized: 'authz 当前没有可运行的同步配置，请先完成同步设置初始化。',
      externalCompleted: '外部数据拉取已完成',
      externalRunFailed: '外部数据拉取启动失败',
      externalResultFailed: '外部数据拉取失败',
      externalResultTimeout: '仍未收到 authz 的最终结果，请稍后查看运行状态。',
      externalSaveFailed: '外部数据同步设置保存失败',
      externalSaved: '外部数据同步设置已保存',
      externalSubmitted: '拉取任务已提交，正在等待 authz 返回结果',
      systemCompleted: 'Hub 组织数据同步已完成',
      systemRunFailed: 'Hub 组织数据同步失败',
      systemSaveFailed: '系统数据同步设置保存失败',
      systemSaved: '系统数据同步设置已保存',
    },
    fields: {
      cron: 'Cron 表达式',
      enabled: '启用定时同步',
    },
    history: {
      columns: {
        duration: '耗时',
        message: '运行信息',
        result: '同步结果',
        scope: '同步范围',
        startedAt: '开始时间',
        status: '状态',
      },
      empty: '暂无 Hub 数据同步记录',
      externalLatestTitle: '外部数据同步最近状态',
      externalLatestTooltip:
        'authz 当前接口只提供最近一次状态，不提供完整历史列表，因此这里不会伪装成外部同步历史。',
      loadErrorDescription: '无法读取 Hub 数据同步记录，请稍后重试。',
      resultCounts: '{{units}} 个组织 / {{relations}} 条成员关系',
      systemRunsTitle: 'Hub 数据同步记录',
      systemRunsTooltip:
        '记录共享源表同步到 Hub 组织视图的运行结果；不代表该次运行重新拉取了外部数据。',
    },
    loadError: '无法加载同步设置',
    result: {
      accounts: '人员账号',
      emptyExternal: '当前 authz 未返回结构化统计。升级 authz 并完成一次成功同步后显示。',
      externalDelta: '新增 {{created}} · 更新 {{updated}} · 停用 {{disabled}}',
      orgUnits: '组织部门',
      relationDelta: '新增 {{created}} · 更新 {{updated}} · 移除 {{removed}}',
      relations: '成员关系',
      skipped: '跳过数据',
      skippedDetail: '组织 {{units}} · 关系 {{relations}}',
      synced: '本次成功同步',
      syncedOrgUnits: '同步组织',
      syncedRelations: '同步成员关系',
      title: '上次同步结果',
      tooltip: '外部同步展示本次快照总量及业务变化；系统同步展示写入 Hub 的数据量和跳过量。',
      warnings: '本次同步包含 {{count}} 条数据警告',
    },
    status: {
      label: '运行状态',
      lastSyncTime: '最近运行时间',
      message: '运行信息',
      values: {
        abandoned: '已放弃',
        failed: '失败',
        running: '运行中',
        success: '成功',
        unknown: '暂无状态',
      },
    },
    system: {
      cronError: '请输入五段式 Cron 表达式。',
      cronHint: '例如：0 2 * * *',
      cronTooltip: 'Hub 使用五段式 Cron，并按 Asia/Shanghai 时区执行。',
      loadErrorDescription: '无法读取 Hub 组织数据同步设置，请检查主服务状态。',
      manualEyebrow: '共享源表 → Hub 组织视图',
      manualTitle: '手动同步到 Hub',
      manualTooltip: '读取当前共享源表并刷新 Hub 组织视图。该操作不会请求任何外部数据源。',
      pipeline: '共享源表 → Hub 组织视图',
      settingsTitle: '系统数据同步设置',
      settingsTooltip:
        '定时同步由 Hub 调度，只负责将现有共享源表同步到 Hub 组织表，不会拉取外部数据。',
      scope: '同步范围',
      scopeOptions: {
        all: '全部组织',
        selected: '指定组织',
      },
      targets: '选择组织',
      targetsEmpty: '共享源表中暂无可同步组织',
      targetsLoadError: '无法加载可同步组织。',
      targetsRequired: '请至少选择一个组织。',
    },
    tabs: {
      external: '外部数据同步',
      history: '运行记录',
      label: '同步管理分栏',
      system: '系统数据同步',
    },
    title: '同步设置',
  },
  pagination: {
    next: '下一页',
    pageSize: '{{count}} 条/页',
    previous: '上一页',
  },
  success: {
    addMember: '成员已加入部门',
    batchDisable: '成员已停用',
    createDepartment: '部门已创建',
    createMemberAccount: '成员账号已创建',
    deleteDepartment: '部门已删除',
    removeMember: '成员已移出部门',
    renameDepartment: '部门已更新',
    resetPassword: '密码已重置',
    updateSettings: '组织设置已更新',
    updateMemberAccount: '成员账号已更新',
    updateStatus: '成员状态已更新',
  },
  temporaryPassword: {
    account: '账号',
    close: '关闭',
    copied: '已复制',
    copy: '复制',
    copyAccount: '复制账号',
    copyFailed: '复制失败，请手动复制',
    copyPassword: '复制密码',
    password: '密码',
    resetHelp: '旧会话已失效；首次登录需改密；密码仅显示一次。',
    resetTitle: '密码已重置',
    title: '账号已创建',
  },
}

export default adminOrganization
